module.exports = __webpack_public_path__ + "media/KRBS 6mb.81227940.mp4";